import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-weekday-date',
  components: {},
})
export default class DisplayFieldWeekdayDate extends mixins(AbstractDisplayField) {
  get formatDate(): string {
    return (
      this.$t(this.$bpcHelper.formatWeekday(this.value)) +
      ' ' +
      this.$bpcHelper.formatDateV2(this.value)
    );
  }
}
